import { initDataAttributesActionClick } from "./click";

export function initDataAttributesAction() {

    initDataAttributesActionClick();

}